<template>
  <div class="login">
    <v-row>
      <v-col cols="2">&nbsp;</v-col>
      <h2>Login</h2>
      <v-col cols="2">&nbsp;</v-col>
    </v-row>
    <v-form ref="loginForm">
      <v-row>
        <v-col cols="2">&nbsp;</v-col>
        <v-col cols="8">
          <b-text-field
              label="Nutzername"
              type="text"
              v-model="name"
              @keydown.enter="login"
              placeholder=" "
              :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="2">&nbsp;</v-col>
      </v-row>
      <v-row>
        <v-col cols="2">&nbsp;</v-col>
        <v-col cols="8">
          <b-text-field
              label="Passwort"
              type="password"
              v-model="passwort"
              @keydown.enter="login"
              placeholder=" "
              :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="2">&nbsp;</v-col>
      </v-row>
      <v-row>
        <v-col>
          <b-btn @click="login()">Login</b-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="showSnackbar" timeout="4000" color="red">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>

import dataMixin from "@/mixins/data-mixin";
import { login as _login } from '@/auth';
import {mapMutations} from "vuex";

export default {
  name: 'Login',
  data() {
    return {
      hint: 'Pflichtfeld',
      rules: {
        required: (value) => !!value || this.hint,
      },
      showSnackbar: false,
      snackbarText: ''
    };
  },
  mixins: [
    dataMixin('name', 'persistentData.name'),
    dataMixin('passwort', 'persistentData.passwort'),
  ],
  methods: {
    ...mapMutations('userData', ['setUserData']),
    login() {
      if (this.$refs.loginForm.validate()) {
        _login(this.name, this.passwort)
          .then((data) => {
            this.setUserData({ userData: 'userName', value: this.name });
            this.setUserData({ userData: 'rolle', value: data.rolle });
            this.setUserData({ userData: 'projekttraegerschaftName', value: data.traegerschaft });
            if (data.changeRequired) {
              this.$router.push('/passwortAendern');
            } else {
              this.$router.push('/projekt');
            }
          })
          .catch((error) => {
            if (error.response.message && error.response.message !== '') {
              this.snackbarText = error.response.message;
            } else {
              this.snackbarText = 'Login fehlgeschlagen. Bitte überprüfen Sie ihre Login-Daten';
            }
            this.showSnackbar = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

.login {
  border: 1px solid #8A8A8A;
  padding: 80px;
  text-align: center;
  width: 66%;
  margin: 80px auto;
  h2 {
    text-align: left;
    padding-left: 12px;
  }
}

</style>